var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"round-cross-button",attrs:{"title":_vm.$t('common.delete')},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("common.delete"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }